import styled from 'styled-components';
import backgroundImage from './../../assets/background-header.webp';

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MainWrapper = styled.div`
  display: flex;
  gap: 20px;
  background-image: url(${backgroundImage});
  background-size: 100% auto;
  background-repeat: repeat-y;
  background-position: top center;
  gap: 16px;
  min-height: 100vh;
  max-width: 100vw;
`;